module.exports = __webpack_public_path__ + "static/media/procoreCard.8dc8902a.mp4";